import { Component } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SigninComponent } from "./auth/signin/signin.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) {}
  openModal() {
    this.modalRef = this.modalService.show(SigninComponent);
  }
}
